const Screen = {
  data() {
    return {
      windowWidth: window.innerWidth,
      mdBootstrapBreakpoint: 768,
    }
  },
  created() {
    window.addEventListener('resize', this.resize);
  },
  destroyed() {
    window.removeEventListener('resize', this.resize);
  },
  methods: {
    resize() {
      this.windowWidth = window.innerWidth;
    }
  },
  computed: {
    isMobile() {
      return this.windowWidth < this.mdBootstrapBreakpoint;
    },
    isDesktop() {
      return this.windowWidth > this.mdBootstrapBreakpoint;
    }
  }
}

export default Screen;
